// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"96364c14","452":"2db45584","453":"2c5e4f4e","975":"742b0b76"}[chunkId] + ".chunk.js";
};